export default __webpack_public_path__ + "static/media/3dtriangle.f9789612.png";